// Ionic & Angular Imports
import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/observable';
import 'rxjs/add/operator/map';

// Provider Imports 
import {Company} from './company.service';

// Interfaces
export interface Subcontractor {
    id: number;
    subcontractor: Company;
    crewsize: number;
    starttime: string;
    finishtime: string;
    notes: string;
}


@Injectable()
export class rsSubcontractorSvc 
{ 
    constructor(
        public http: Http, 
    ) {
        // Class constructor
    }

    getSubcontractors( reportId : number ) : Observable<Subcontractor[]> {
        return Observable.create( observer => {

            this.http.get( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/subcontractor', {
                withCredentials: true
            })
            .map( res => res.json().response.subcontractors )
            .subscribe( result => {
                observer.next(result);
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });
    }

    addSubcontractor( subId : number, crewsize: number, starttime: string, finishtime: string, notes: string, reportId : number ) : Observable<Subcontractor> {
        return Observable.create( observer => {

            let postData = {
                subcontractorid: subId,
                crewsize : crewsize,
                starttime : starttime,
                finishtime : finishtime,
                notes : notes
            };

            let body = JSON.stringify(postData);
            let headers = new Headers( {
                'Content-Type' : 'application/json'
            });
            let options = new RequestOptions( { headers: headers, withCredentials : true } );
            this.http.post( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/subcontractor', body, options )
            .map( res => res.json().response.subcontractors )
            .subscribe( result => {
                observer.next(result);
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });
    };

    updateSubcontractor( subId : number, crewsize : number, companyId: number, starttime: string, finishtime: string, notes: string, reportId : number ) : Observable<Subcontractor> {
        return Observable.create( observer => {

            let patchData = {
                subcontractorid: companyId,
                crewsize: crewsize,
                starttime : starttime,
                finishtime : finishtime,
                notes : notes
            };

            let body = JSON.stringify(patchData);
            let headers = new Headers({
                'Content-Type' : 'application/json'
            });
            let options = new RequestOptions( { headers: headers, withCredentials: true } );
            this.http.patch( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/subcontractor/' + subId, body, options )
            .map( res => res.json().response.subcontractors )
            .subscribe( result => {
                observer.next(result);
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });  
    }
    
    deleteSubcontractor( subId : number, reportId : number ) : Observable<void> {
        return Observable.create( observer => {

            this.http.delete( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/subcontractor/' + subId, {
                withCredentials: true
            })
            .map( res => res.json() )
            .subscribe( result => {
                observer.next(result);
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/subcontractor.service.ts